import { apiRequest } from "./api";

export type TaskStatus = "TODO" | "IN_PROGRESS" | "DONE" | "BLOCKED";
export type TaskPriority = "LOW" | "MEDIUM" | "HIGH";

export interface TaskUpdate {
  note: string;
  updatedAt: string;
  updatedBy: string;
}

export interface Task {
  taskId: string;
  assignedTo: string;
  assigneeName?: string;
  createdBy: string;
  businessId?: string;
  title: string;
  description: string;
  priority: TaskPriority;
  dueDate?: string;
  status: TaskStatus;
  updates: TaskUpdate[];
  createdAt: string;
  updatedAt: string;
}

export interface CreateTaskPayload {
  assignedTo: string;
  title: string;
  description?: string;
  priority?: TaskPriority;
  dueDate?: string;
}

export const taskApi = {
  // Employee
  listMine: (status?: TaskStatus, params?: { limit?: number; cursor?: string }) =>
    apiRequest<{ items: Task[]; nextCursor: string | null }>("/me/tasks", {
      params: {
        ...(status ? { status } : {}),
        limit: params?.limit ?? 10,
        ...(params?.cursor ? { cursor: params.cursor } : {}),
      },
    }),
  getMine: (taskId: string) =>
    apiRequest<{ task: Task }>(`/me/tasks/${taskId}`),
  updateStatus: (taskId: string, status: TaskStatus) =>
    apiRequest<{ success: boolean }>(`/me/tasks/${taskId}/status`, {
      method: "PATCH",
      body: { status },
    }),
  addUpdate: (taskId: string, note: string) =>
    apiRequest<{ success: boolean }>(`/me/tasks/${taskId}/updates`, {
      method: "POST",
      body: { note },
    }),

  // Admin
  adminCreate: (payload: CreateTaskPayload) =>
    apiRequest<Task>("/admin/tasks", { method: "POST", body: payload }),
  adminList: (status: TaskStatus = "TODO", limit = 50, lastKey?: string) =>
    apiRequest<{ items: Task[]; nextKey: string | null }>("/admin/tasks", {
      params: { status, limit, lastKey },
    }),
};
